/*
Ashraf 01/11/2023 2699710829 all screens render for audit list

*/
import React, {useEffect, useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AppContext from '../../../../components/contextProvider/AppContextProvider/AppContext';
import SearchFieldList from './SearchClientAuditList';
import SaveAlert from '../../../../components/DialogBox/SaveAlert';


const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchButtons': {
    margin: '-8px 0 8px',
  },

  'popup': {
    background: 'black',
  },
}));

export default function SubTabsContent({setTableValue, StepperFieldList, AuditFieldList}) {
  const classes = useStyles();
  const [tabvalue, setTabValue] = useState(0);
  const {reportMasterId} = useContext(AppContext);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (reportMasterId !== '') {
      setTabValue(1);
    }
  }, [reportMasterId]);


  return (
  // Removed sub tabs (2700799562)
    <div className={classes.root}>
      <div className={classes.searchButtons}>
        {open && (
          <SaveAlert setTabValue={setTabValue} setOpen={setOpen} open={open} tabvalue={tabvalue} />
        )}
        <Typography />
      </div>
      <div className={classes.subContent}>
        {tabvalue === 0 ? (
          <SearchFieldList
            setTabValue={setTabValue}
            StepperFieldList={StepperFieldList}
            AuditFieldList={AuditFieldList}
          />
        ) :
          tabvalue === 1 ? (
            <></>
          ) :
            tabvalue === 2 ? (
              <></>
            // <UsageFieldList
            //     fieldListRowData={fieldListRowData}
            //     setTabValue={setTabValue}
            //     setUsageState={setUsageState}
            //     rowSelected={rowSelected}
            //     AuditFieldList={AuditFieldList}
            // />
            ) : null}
      </div>
    </div>
  );
}
